import { getEnvironment } from "@sunrun/sales-experience-shared";
import axios from "axios";

const getProposalServiceUrl = () => {
  switch (getEnvironment()) {
    case "production":
      return "https://gateway.sunrun.com/splat-proposal-service";
    case "relcert":
      return "https://gateway.sunrunstage.com/relcert-proposal-service";
    case "staging":
    default:
      return "https://gateway.sunrun.com/majstg-splat-proposal-service";
  }
};

const sendProposalEmail = async (
  hybridToken: string,
  prospectId: string,
  optionalNote: string,
  type: "ONE" | "CAP"
) => {
  try {
    const postData = {
      optionalNote,
      prospectId,
      emailType: `${type}_PROPOSAL`,
    };

    const url = getProposalServiceUrl();
    await axios.post(`${url}/sendEmail`, postData, {
      headers: {
        Authorization: hybridToken,
        "Access-Control-Allow-Origin": "*",
      },
    });
  } catch (error) {
    throw new Error("Failed to send proposal email.", { cause: error });
  }
};

const sendProposalMessageAndEmail = async (
  hybridToken: string,
  prospectId: string,
  optionalNote: string,
  isCap?: boolean,
  isOne?: boolean
) => {
  try {
    const postData = {
      optionalNote,
      prospectId,
      isCap,
      isOne,
    };

    const url = getProposalServiceUrl();
    await axios.post(`${url}/sendMessageAndEmail`, postData, {
      headers: {
        Authorization: hybridToken,
        "Access-Control-Allow-Origin": "*",
      },
    });
  } catch (error) {
    throw new Error("Failed to send proposal message and email.", {
      cause: error,
    });
  }
};

export { sendProposalEmail, sendProposalMessageAndEmail };
